import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=16df09c6&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"
import style0 from "./Spinner.vue?vue&type=style&index=0&id=16df09c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16df09c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16df09c6')) {
      api.createRecord('16df09c6', component.options)
    } else {
      api.reload('16df09c6', component.options)
    }
    module.hot.accept("./Spinner.vue?vue&type=template&id=16df09c6&scoped=true", function () {
      api.rerender('16df09c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/Spinner.vue"
export default component.exports